@if (theme().cover.design === 'simple') {
  <app-cover-design-simple
    [gallery]="gallery()"
    [theme]="theme()"
    [previewAsset]="previewAsset()"
    [noAsset]="noAsset()"
    [animated]="animated()"
  ></app-cover-design-simple>
} @else if (theme().cover.design === 'faded') {
  <app-cover-design-fade
    [gallery]="gallery()"
    [theme]="theme()"
    [previewAsset]="previewAsset()"
    [noAsset]="noAsset()"
    [animated]="animated()"
  ></app-cover-design-fade>
} @else if (theme().cover.design === 'frame') {
  <app-cover-design-frame
    [gallery]="gallery()"
    [theme]="theme()"
    [previewAsset]="previewAsset()"
    [noAsset]="noAsset()"
    [animated]="animated()"
  ></app-cover-design-frame>
} @else if (theme().cover.design === 'stripes') {
  <app-cover-design-stripes
    [gallery]="gallery()"
    [theme]="theme()"
    [previewAsset]="previewAsset()"
    [noAsset]="noAsset()"
    [animated]="animated()"
  ></app-cover-design-stripes>
}
